module.exports = __webpack_public_path__ + "assets/img/WechatIMG52.10b34311.png";